import { useEffect } from 'react';

export default function useModalCleanup(isModalOpen) {
  useEffect(() => {
    if (!isModalOpen) {
      setTimeout(() => {
        const anyModalOpen = !!document.querySelector('.modal.show, .modal[style*="display: block"]');
        if (!anyModalOpen) {
          document.body.classList.remove('modal-open');
          if (document.body.style.overflow === 'hidden') {
            document.body.style.overflow = '';
          }
        }
      }, 200);
    }
  }, [isModalOpen]);
} 